import { NgModule } from '@angular/core';
import { GCCoreModule } from '@core/_core.module';

@NgModule({
  imports: [ GCCoreModule ]
})
export class ProgramFormsModule {}
